module.exports = "/reports/components/configureTableColumnsComponent-24b4cd.html";